import { useState } from "react";
import { Users, ShieldCheck } from "lucide-react";
import Onboarding from "./Onboarding";
import RolesAndModules from "./RolesAndModules";

/* ---------------------------------------------------------
   TeamManagement — thin wrapper that restores the tab switcher
   on top of the two standalone components.
--------------------------------------------------------- */
export default function TeamManagement() {
    const [tab, setTab] = useState("onboarding");

    return (
        <div className="h-screen overflow-y-auto custom-scrollbar bg-gray-50">
            <style>{`
                .custom-scrollbar {
                    scrollbar-width: thin; /* Firefox */
                    scrollbar-color: #cbd5e1 transparent; /* Firefox: thumb, track */
                }
                .custom-scrollbar::-webkit-scrollbar {
                    width: 10px;
                }
                .custom-scrollbar::-webkit-scrollbar-track {
                    background: transparent;
                }
                .custom-scrollbar::-webkit-scrollbar-thumb {
                    background-color: #cbd5e1; /* slate-300 */
                    border-radius: 9999px;
                    border: 2px solid #f8fafc; /* creates padding around thumb, gray-50 */
                }
                .custom-scrollbar::-webkit-scrollbar-thumb:hover {
                    background-color: #94a3b8; /* slate-400 */
                }
            `}</style>

            {/* Tab switcher bar */}
            <div className="max-w-6xl mx-auto px-6 lg:px-8 pt-6 lg:pt-8">
                <div className="inline-flex bg-white border border-slate-200 rounded-full p-1">
                    <button
                        onClick={() => setTab("onboarding")}
                        className={`flex items-center gap-2 text-sm font-semibold px-4 py-2 rounded-full transition ${tab === "onboarding"
                            ? "bg-gradient-to-r from-blue-500 to-indigo-600 text-white"
                            : "text-slate-500 hover:text-slate-800"
                            }`}
                    >
                        <Users size={15} /> Onboarding
                    </button>
                    <button
                        onClick={() => setTab("roles")}
                        className={`flex items-center gap-2 text-sm font-semibold px-4 py-2 rounded-full transition ${tab === "roles"
                            ? "bg-gradient-to-r from-blue-500 to-indigo-600 text-white"
                            : "text-slate-500 hover:text-slate-800"
                            }`}
                    >
                        <ShieldCheck size={15} /> Roles & modules
                    </button>
                </div>
            </div>

            {/* Active tab content — each component renders its own
                header, stat cards, and padding, so no extra wrapper needed */}
            {tab === "onboarding" ? <Onboarding /> : <RolesAndModules />}
        </div>
    );
}